<template>

  <div>
    <el-collapse v-if="sharers.length > 0" accordion>

      <el-collapse-item v-for="s in sharers" :key="s.id">
        <template #title>
          <i :class="'fa ' + (s.status == 'Terminated' ? 'fa-user-slash text-danger' : 'fa-users text-primary')"/>&nbsp;<em class="text-black">{{s.organisation.name}}</em>
        </template>

        <finance-sharer :sharer="s" :site-data="rowData" />
      </el-collapse-item>

    </el-collapse>
    <center v-else style="padding-top: 0.528em;">No sharers found.</center>
  </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'
import FinanceSharer from '@/components/sites/finance/sharer/FinanceSharer'

export default {

  mixins: [SiteMixins],

  components: {
    FinanceSharer
  },

  props: {

    rowData: {
      type: Object,
      required: true
    },

    sharers: {
      type: [Array, Object],
      required: true
    }

  }
}

</script>
